import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { defaultFixtureRosterExportFieldNames } from "~pages/Roster/FixtureRosterListPage/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportFixtureRoster = (entityId: string, fixtureId: string) => {
  const { sport = "", organizationId = "" } = useParams();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) => {
      const body = {
        fieldNames: fieldNames || defaultFixtureRosterExportFieldNames,
      };

      return await request(`${sport}/o/${organizationId}/fixtures/${fixtureId}/entities/${entityId}/roster/export`, {
        method: "POST",
        body,
      });
    },
  });
};
